export const tinResponseProps: Set<string> = new Set([
  'Category',
  'Cell',
  'DetailedAddress',
  'District',
  'EmailAddress',
  'ManagerNames',
  'NationalId',
  'PhoneNumber',
  'Province',
  'SupplierName',
  'SupplierTin',
  'Village',
  'Sector',
]);
